import { render, staticRenderFns } from "./AtomText.vue?vue&type=template&id=e44577f0&"
import script from "./AtomText.vue?vue&type=script&lang=js&"
export * from "./AtomText.vue?vue&type=script&lang=js&"
import style0 from "./AtomText.vue?vue&type=style&index=0&id=e44577f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports